<template>
  <div>
    <TopBar v-if="msalInitialised && isLoggedIn"></TopBar>
    <NavBar v-if="msalInitialised && isLoggedIn"></NavBar>
    <LoginBar v-if="msalInitialised" :is-logged-in="isLoggedIn"></LoginBar>
    <div class="main-content" v-if="isLoggedIn">
      <div class="top-menu">
        <Breadcrumb class="ms-bread-crumb"></Breadcrumb>
        <ProjectSelector></ProjectSelector>
      </div>
      <div class="page-content" v-if="store.projectHasBeenSet || isAdminPage">
        <RouterView></RouterView>
      </div>

      <div class="page-content loading" v-else>
        <div v-if="store.noProjects">
          <h1>No Projects Available</h1>
        </div>
        <div class="spinner-border" role="status" v-else>
          <span class="visually-hidden">Loading Project...</span>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!isLoggedIn && msalInitialised" class="image-container">
    <img src="@/assets/img/NKT-Service-Victoria_Dock.jpg" alt="logo" class="responsive-image" />
  </div>
</template>

<script setup lang="ts">
import TopBar from './components/nav/TopBar.vue'
import NavBar from './components/nav/NavBar.vue'
import LoginBar from './components/nav/LoginBar.vue'
import Breadcrumb from './components/general/breadcrumbs/Breadcrumb.vue'
import ProjectSelector from './components/dropdowns/ProjectSelector.vue'
import { useProjectStore } from './stores/ProjectStore'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import { MSAL } from './plugins/msal/msal'
import { useRoute } from 'vue-router'

const msal: MSAL = getCurrentInstance()?.appContext.config.globalProperties.$msal
let store = useProjectStore()

const isLoggedIn = ref(false)
const msalInitialised = ref(false)

const route = useRoute()
const isAdminPage = computed(() => route?.meta?.isAdminPage ?? false)

onMounted(async () => {
  await msal.initialize()

  isLoggedIn.value = msal.isAuthenticated()
  msalInitialised.value = true
})
</script>

<style lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.page-content {
  position: relative;
  height: 100%;
}

body {
  background-color: color.$color-lighter-grey;
  overflow: hidden; /* Completely prevent page-level scrollbars */
}

html {
  overflow: hidden; /* Prevent scrollbars at root level */
}

.ms-top-bar-color {
  background-color: color.$color-nordic-blue-base;
}

.page-content.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.top-menu {
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.breadcrumb-nav {
  margin: 0 !important; /* Removes default margin */
}

.breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
}

.dropdown {
  margin: 0;
}

.ms-top-bar {
  height: 40px;
}

.ms-bread-crumb {
  margin-left: 12px;
}

.main-content {
  transition: all 0.3s ease;
  height: calc(100vh - 105px);
  margin-top: var(--topbar-height, 60px); /* Dynamic margin based on topbar height */
  position: relative;
}

:has(.navbar-vertical:not([style*='display: none'])) ~ .main-content {
  --bs-navbar-vertical-width: 332px;
}

:has(.navbar-vertical-sm:not([style*='display: none'])) ~ .main-content {
  --bs-navbar-vertical-width: 112px;
}

.navbar-vertical {
  --bs-navbar-vertical-width: 332px;
}

.navbar-vertical-sm {
  --bs-navbar-vertical-width: 112px;
}

.image-container {
  position: relative; /* Ensures proper positioning for the child elements */
  width: 100%; /* Matches the width of the parent container */
  height: 100vh; /* Sets the height to 100% of the viewport height */
  display: flex;
  align-items: flex-start; /* Aligns the image at the top */
  justify-content: flex-start; /* Aligns the image to the left */
  overflow: hidden; /* Ensures no unwanted scrollbars */
}

.responsive-image {
  width: 100%; /* Ensures the image scales to 100% of the width */
  height: 100%; /* Ensures the image scales to 100% of the height */
  object-fit: cover; /* Ensures the image covers the entire area while maintaining aspect ratio */
}
</style>
